import React, { PureComponent } from 'react'
import { injectIntl } from 'react-intl'

import { Avatar } from 'src/components/Avatar/Avatar'
import { EventSection } from 'src/components/calendar/eventSection'
import { LoadingContent } from 'src/components/loading-content/LoadingContent'
import { LoadingPlaceholder } from 'src/components/loading-content/LoadingPlaceholder'
import { HOST_ID } from './constants'

import style from './host.css'
import locale from './locale'

const Placeholder = () => (
  <LoadingPlaceholder modifierClass={style.placeholder}>
    <LoadingContent width="170px" height="25px" borderRadius="rounder" />
    <div className={style.columnContainer}>
      <LoadingContent width="64px" height="64px" borderRadius="half" />

      <div className={style.info}>
        <LoadingContent width="30%" height="18px" />
        <LoadingContent width="20%" height="14px" />

        <LoadingContent width="90%" height="14px" />
        <LoadingContent width="90%" height="14px" />
        <LoadingContent width="90%" height="14px" />
      </div>
    </div>
  </LoadingPlaceholder>
)

class HostComponent extends PureComponent {
  /* NOTE: This seems a bit fragile. Would these strings be better suited elsewhere */
  get userProfileUrl() {
    return `/users/${this.props.eventData.user.id}`
  }

  get userMessagingUrl() {
    return `/dashboard/conversations/withUser/${this.props.eventData.user.id}`
  }

  renderInfo() {
    const { isMobile, eventData: { user }, eventData, intl: { formatMessage } } = this.props

    const description = new DOMParser().parseFromString(user.description || '', 'text/html')
    let parsedstr
    if (description.documentElement) {
      parsedstr = description.documentElement.textContent
    }

    // hide the host city for Encore Live (garth brooks) events
    const showCity = !/Encore (Live|Drive)/ig.test(user.description)
    const euCountries = ['AX', 'AT', 'BE', 'DK', 'FI', 'DE', 'FR', 'IM', 'NL', 'ES', 'SE', 'GB']
    const isEuCountry = eventData.countryCode ? euCountries.includes(eventData.countryCode) : false

    return (
      <div className={isMobile ? style.columnInfo : style.rowInfo}>
        <a className={style.link} href={this.userProfileUrl}>
          <h4 className={style.heading}>{eventData.user.name}</h4>
        </a>
        { showCity &&
          <h5 className={style.subheading}>{eventData.user.location}</h5>
        }
        { user.description &&
          <p className={style.description}>{parsedstr}</p>
        }
        { user.isBusinessSeller && isEuCountry &&
        <div>
          <h4 className={style.bsiSubheading}>{formatMessage(locale.businessSeller)}</h4>
          <h5 className={style.bsiRow}>{user.businessAddress}</h5>
          <h5 className={style.bsiRow}>{user.businessPhoneNumber}</h5>
          <h5 className={style.bsiEmail}>{user.businessEmail}</h5>
        </div>
        }
        { user.messageable &&
          <a className={style.link} rel="nofollow" href={this.userMessagingUrl}>
            {formatMessage(locale.contactHost)}
          </a>
        }

      </div>
    )
  }

  render() {
    const { isMobile, loading, intl: { formatMessage } } = this.props

    if (loading) {
      return <Placeholder />
    }

    return (
      <EventSection sectionId={HOST_ID} heading={formatMessage(locale.host)}>
        <div className={isMobile ? style.columnContainer : style.rowContainer}>
          <a className={style.link} href={this.userProfileUrl}>
            <Avatar user={this.props.eventData.user} className={style.avatar} />
          </a>
          {this.renderInfo()}
        </div>
      </EventSection>
    )
  }
}

export const Host = injectIntl(HostComponent)
